// extracted by mini-css-extract-plugin
export default {"container":"DefaultContainer_container__0t0l3"};